<template>
<div>
  <div class="vx-row">
    <div class="vx-col md:w-1/3 w-full mt-5">
      <vs-input :label="$t('name') | capitalize" v-model="data.name" class="w-full" name="Name" v-validate="'required'" />
      <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5">
      <vs-input :label="$t('short_name') | capitalize" v-model="data.shortName" class="w-full" name="Short Name" v-validate="'required'" />
      <span class="text-danger text-sm" v-show="errors.has('Short Name')">{{ errors.first('Short Name') }}</span>
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5">
      <vs-input :label="$t('sca_file_name') | capitalize" v-model="data.scaFileName" class="w-full" name="SCA File Name" v-validate="'required'" />
      <span class="text-danger text-sm" v-show="errors.has('SCA File Name')">{{ errors.first('SCA File Name') }}</span>
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5">
      <vs-input :label="$t('address') + ' 1'| capitalize" v-model="data.address1" class="w-full" name="Address 1" v-validate="'required'" />
      <span class="text-danger text-sm" v-show="errors.has('Address 1')">{{ errors.first('Address 1') }}</span>
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5">
      <vs-input :label="$t('address') + ' 2' | capitalize" v-model="data.address2" class="w-full" name="Address 2" />
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5">
      <vs-input :label="$t('city') | capitalize" v-model="data.addressCity" class="w-full" name="City" v-validate="'required'" />
      <span class="text-danger text-sm" v-show="errors.has('City')">{{ errors.first('City') }}</span>
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5">
      <vs-input :label="$t('zip') | upperCase" v-model="data.addressZip" class="w-full" name="Zip" v-validate="'required|min:5'" />
      <span class="text-danger text-sm" v-show="errors.has('Zip')">{{ errors.first('Zip') }}</span>
    </div>
  </div>
  <div class="vx-row mt-5">
    <div class="vx-col md:w-1/3 w-full mt-5">
      <vs-input type="nu5er" :label="$t('max_hours_for_regular_rate') | capitalize" v-model="data.maxHours" class="w-full" name="Max Hours For Regular Rate" v-validate="'required|min_value:0'" />
      <span class="text-danger text-sm" v-show="errors.has('Max Hours For Regular Rate')">{{ errors.first('Max Hours For Regular Rate') }}</span>
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5">
      <vs-input type="number" :label="$t('above_hourly_rate') | capitalize" v-model="data.aboveHourlyRate" class="w-full" name="Above Gourly Rate" v-validate="'required|min_value:0'" />
      <span class="text-danger text-sm" v-show="errors.has('Above Gourly Rate')">{{ errors.first('Above Gourly Rate') }}</span>
    </div>
  </div>
  <div class="vx-row mt-5">
    <div class="vx-col md:w-1/3 w-full mt-5">
      <vs-input :label="$t('mxn_funds_transfer') | capitalize" v-model="data.mxnFundsTransferInfo" class="w-full" name="MXN Funds Transfer Info" />
      <span class="text-danger text-sm" v-show="errors.has('MXN Funds Transfer Info')">{{ errors.first('MXN Funds Transfer Info') }}</span>
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5">
      <vs-input :label="$t('usd_funds_transfer') | capitalize" v-model="data.usdFundsTransferInfo" class="w-full" name="USD Funds Transfer Info" />
      <span class="text-danger text-sm" v-show="errors.has('USD Funds Transfer Info')">{{ errors.first('USD Funds Transfer Info') }}</span>
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5">
      <vs-input type="number" :label="$t('invoice_day') | capitalize" v-model="data.invoiceDay" class="w-full" name="Invoice Day" v-validate="'required|min_value:1|max_value:7'" />
      <span class="text-danger text-sm" v-show="errors.has('Invoice Day')">{{ errors.first('Invoice Day') }}</span>
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5">
      <label for="">{{$t('schedule_day_invoice') | capitalize}}</label>
      <v-select v-model="data.scheduleDayInvoice" class="w-full" label="name" :placeholder="$t('schedule_day_invoice') | capitalize" :options="days" :reduce="item => item.id" :clearable="false" />
    </div>
    <div class="vx-col md:w-1/3 w-full mt-2">
      <vs-checkbox v-model="data.entryReport" class="mt-6 checkbox-center">{{ $t('entry_report') | capitalize }}</vs-checkbox>
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5">
      <label for="">{{$t('frequency') | capitalize}} ({{$t('days') | capitalize}}) </label>
      <vs-input type="number" v-model="data.entryReportFrequency" class="w-full" name="Frequency" v-validate="'required|min_value:1|max_value:30'"   :disabled="data.entryReport != true"/>
    </div>
  </div>

  <div class="vx-row mt-5">
    <div class="vx-col md:w-1/3 w-full mt-5">
      <vs-input :label="$t('warehouse_code') | capitalize" v-model="data.code" class="w-full" name="Code" v-validate="'required'" />
      <span class="text-danger text-sm" v-show="errors.has('Code')">{{ errors.first('Code') }}</span>
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5">
      <vs-input :label="$t('darwin_account') | capitalize" v-model="data.darwinAccount" class="w-full" name="Darwin Account"/>
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5">
      <v-swatches v-model="data.color" show-fallback fallback-input-type="color" popover-x="left"  popover-y="top" class="w-full">
        <vs-input slot="trigger" :label="$t('color') | capitalize" v-model="data.color" class="w-full" readonly :style="{color:data.color}" />
      </v-swatches>
    </div>
  </div>
  <div class="vx-row mt-5">
    <div class="vx-col md:w-1/3 w-full mt-5 ">
      <vs-checkbox v-model="data.canMultireview" class="mt-6 checkbox-center">{{ $t('can_multireview') | capitalize }}</vs-checkbox>
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5">
      <vs-checkbox v-model="data.isDirectFundsMode" class="mt-6 checkbox-center"> {{ $t('is_direct_funds_mode') | capitalize }}</vs-checkbox>
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5 ">
      <vs-checkbox v-model="data.isActive" class="mt-6 checkbox-center">{{ $t('is_active') | capitalize }}</vs-checkbox>
    </div>
  </div>
  <div class="vx-row mt-5">
    <div class="vx-col md:w-1/6 w-full mt-5 ml-auto">
      <vs-button color="primary" type="filled" @click="submit" class="w-full" :disabled="disabledSubmit">
        {{ $t('save') | capitalize }}
      </vs-button>
    </div>
  </div>
</div>
</template>

<script>
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'
import vSelect from 'vue-select'
export default {
  components: {
    VSwatches,
    'v-select': vSelect,
  },

  computed: {
    disabledSubmit() {
      return this.errors.any() ||
        this.data.name === '' ||
        this.data.shortName === '' ||
        this.data.address1 === '' ||
        //this.data.address2 === '' ||
        this.data.addressZip === '' ||
        this.data.addressCity === '' ||
        this.data.maxHours === '' ||
        this.data.aboveHourlyRate === '' ||
        this.data.scaFileName === '' ||
        //this.data.mxnFundsTransferInfo === '' ||
        //this.data.usdFundsTransferInfo === '' ||
        this.data.invoiceDay === '' ||
        this.data.scheduleDayInvoice === '' ||
        this.data.code === '' ||
        //this.data.darwinAccount === '' ||
        this.data.color === ''
    }
  },

  data: () => ({
    days: [
      {
        id: '2',
        name: 'Tuesday - 5 AM'
      },
      {
        id: '3',
        name: 'Wednesday - 5 AM'
      }
    ],
  }),

  methods: {
    submit() {
      this.$validator.reset()
      this.$emit('submit', this.data)
    }
  },

  props: {
    data: {
      default: () => ({
        name: '',
        shortName: '',
        address1: '',
        address2: '',
        addressZip: '',
        addressCity: '',
        maxHours: '',
        aboveHourlyRate: '',
        scaFileName: '',
        mxnFundsTransferInfo: '',
        usdFundsTransferInfo: '',
        invoiceDay: '',
        scheduleDayInvoice: '',
        canMultireview: false,
        isDirectFundsMode: false,
        code: '',
        darwinAccount: '',
        color: '',
        isActive:false,
        entryReport:false,
        entryReportFrequency:2
      })
    },
  }

}
</script>
<style>
.vue-swatches__trigger__wrapper {
  display: block;
  cursor: pointer
}

.checkbox-center {
  margin-top: 30px !important;
}

</style>
